
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SupernovaEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;
        const cycle = (curTime * 0.5) % 1;
        
        ctx.fillStyle = pc.color;

        const draw = () => {
             // Explosion core
             const r = cycle * Math.max(width, height) * 2 * scale;
             const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
             grad.addColorStop(0, pc.color);
             grad.addColorStop(0.2, pc.color);
             grad.addColorStop(1, 'transparent');
             
             ctx.save();
             ctx.globalAlpha = (1 - cycle) * 0.4 / layerIndex;
             ctx.fillStyle = grad;
             ctx.beginPath();
             ctx.arc(0, 0, r, 0, Math.PI * 2);
             ctx.fill();

             // Shockwave fragments
             const fragments = Math.floor(50 * (config.parallaxComplexity || 1.0));
             for (let i = 0; i < fragments; i++) {
                 const angle = (i / fragments) * Math.PI * 2 + cycle * 2;
                 const fr = r * (0.8 + this.pseudoRandom(i) * 0.2);
                 const fx = Math.cos(angle) * fr;
                 const fy = Math.sin(angle) * fr;
                 const fs = (10 + this.pseudoRandom(i) * 30) * (1 - cycle) * scale;
                 
                 ctx.beginPath();
                 ctx.arc(fx, fy, fs, 0, Math.PI * 2);
                 ctx.fill();
             }
             ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
